import { useSessionStore } from 'store/server-context/session'
import { baseFetch } from './base'

export const clientFetch = baseFetch(() => useSessionStore.getState().v2Token)
